import React from 'react'
import { generateMeta } from '@/utils/meta'
import { Helmet } from 'react-helmet-async'
import { useSelector } from "react-redux"
import { useLocation } from "react-router"

export default function MetaComponent({meta}) {
  const { pathname } = useLocation();
  const defaultMeta = {
    description: "Find homes for sale through online real estate auctions on Hubzu. Browse foreclosed properties, bank-owned homes, and investment properties with transparent bidding.",
    keywords: "real estate auctions, homes for sale, foreclosed properties, bank owned homes, online property auctions"
  }
  const srpInitData = useSelector((state) => state.srp.srpInitData);
  const generatedMeta = generateMeta({data: {city: srpInitData?.city, state: srpInitData?.state, stateName: srpInitData?.stateName}, specialLandingUrlSuffix: pathname})
  return (
      <Helmet>
        <title>
          {meta?.title || generatedMeta?.title}
        </title>
        <meta name='description' content={meta?.description || generatedMeta?.metaTags || defaultMeta?.description} />
        <meta name='keywords' content={meta?.keywords || generatedMeta?.metaKeyWords || defaultMeta?.keywords} />
      </Helmet>
  )
}
